import { Plugs } from '@phosphor-icons/react';

export default Plugs;
